import { Component, OnDestroy, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { WorkspaceService } from '../shared/services/workspace.service';
import { CurrentWorkspaces } from '../shared/models/workspace/currentWorkspaces';
import { Workspace } from '../shared/models/workspace/workspace';

@Component({
  selector: 'workspace-nav',
  templateUrl: './workspace-nav.component.html',
  styleUrls: ['./workspace-nav.component.scss'],
  standalone: false
})
export class WorkspaceNavComponent implements OnInit, OnDestroy {
  subs: Subscription[] = [];
  currentWorkspaces: CurrentWorkspaces;
  orgHasWorkspaces = false;

  constructor(
    public authService: AuthService,
    private workspaceService: WorkspaceService
  ) {}

  ngOnInit(): void {
    this.subs.push(
      this.workspaceService.orgHasWorkspaces.subscribe((result) => (this.orgHasWorkspaces = result))
    );
    this.subs.push(
      this.workspaceService.currentWorkspaces
        .pipe(
          map((cws) => {
            if (!cws) return null;
            return cws as CurrentWorkspaces;
          })
        )
        .subscribe((result) => {
          if (result) {
            this.currentWorkspaces = result;
          }
        })
    );
  }

  get activeWorkspace(): Workspace {
    return this.currentWorkspaces.activeWorkspace;
  }

  get activeWorkspaceName(): string {
    if (this.currentWorkspaces && this.currentWorkspaces.activeWorkspace) {
      return this.currentWorkspaces.activeWorkspace.name;
    }
  }

  get workspaces(): Workspace[] {
    if (this.currentWorkspaces && this.currentWorkspaces.workspaces) {
      return this.currentWorkspaces.workspaces;
    }
    return [];
  }

  selectWorkspace(workspace: Workspace) {
    this.workspaceService.updateActiveWorkspace(workspace);
  }

  isOrgWorkspace(workspace: Workspace) {
    return workspace.id === null;
  }

  isActiveWorkspace(workspace: Workspace): boolean {
    return this.activeWorkspace.id == workspace.id;
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
